/* 特集LP（楽天GOLD feature/ からの移植）の共通スクリプト。
   楽天版は jQuery + SmoothScroll + jquery.lazyload + scrollreveal を読み込んでいたが、
   実際に使っていたのは次の3つだけだったので、素のJSで書き直してある。
   （scrollreveal は読み込まれているだけで呼び出しが無く、未使用だった） */
(function () {
  'use strict';
  var root = document.querySelector('.lp-uvcut, .lp-tshirts, .lp-aseshimi, .lp-ajihen');
  if (!root) return;

  /* 1) ページ内アンカーのスムーススクロール（元: SmoothScroll speed:200 offset:50） */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || !root.contains(a)) return;
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.indexOf('#') < 0) return;
    var id = href.slice(href.indexOf('#') + 1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 50, behavior: 'smooth' });
  });

  /* 2) スクロールで下から上にふわっと出す（元: .fadein に .scrollin を付ける） */
  var fadeins = root.querySelectorAll('.fadein');
  if (fadeins.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('scrollin'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -150px 0px' });
      Array.prototype.forEach.call(fadeins, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(fadeins, function (el) { el.classList.add('scrollin'); });
    }
  }

  /* 3) ページトップへ戻るボタン（500px スクロールで出す） */
  var top = root.querySelector('#page-top');
  if (top) {
    top.style.display = 'none';
    var onScroll = function () { top.style.display = window.pageYOffset > 500 ? '' : 'none'; };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    top.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
